import auth from './routes/auth';
import orders from './routes/orders';
import processing from './routes/processing';
import shipments from './routes/shipments';
import files from './routes/files';

const routes = [
  {
    path: '/',
    redirect: { name: 'processing' },
  },
  ...auth,
  ...orders,
  ...processing,
  ...shipments,
  ...files,
];

export default routes;
